import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-permissions-page',
  templateUrl: './no-permissions-page.component.html',
  styleUrls: ['./no-permissions-page.component.scss']
})
export class NoPermissionsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
